// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.markdown-body pre {
    background: rgba(240, 240, 245, 0.9);
    border-radius: 0.5rem;
    padding: 1rem;
    margin: 1rem 0;
    border: 1px solid rgba(0, 0, 0, 0.1);
    overflow-x: auto;
}

.dark .markdown-body pre {
    background: rgba(28, 28, 48, 0.9);
    border: 1px solid rgba(255, 255, 255, 0.08);
}

.markdown-body code {
    background: rgba(240, 240, 245, 0.75);
    border-radius: 0.25rem;
    padding: 0.1rem 0.3rem;
    font-size: 0.9em;
    color: #333;
    font-family: monospace;
}

.dark .markdown-body code {
    background: rgba(28, 28, 48, 0.75);
    color: #f8fafc;
}

.markdown-body pre code {
    background: transparent;
    padding: 0;
    border-radius: 0;
}

.markdown-body blockquote {
    border-left: 4px solid rgba(99, 102, 241, 0.5);
    padding-left: 1rem;
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
    margin-bottom: 1rem;
    background: rgba(245, 245, 250, 0.5);
    border-radius: 0.25rem;
}

.dark .markdown-body blockquote {
    background: rgba(22, 22, 38, 0.3);
}

.markdown-body a {
    color: #4f46e5;
    text-decoration: underline;
    transition: color 0.15s ease;
}

.dark .markdown-body a {
    color: #6366f1;
}

.markdown-body a:hover {
    color: #6366f1;
}

.dark .markdown-body a:hover {
    color: #818cf8;
}

.markdown-body table {
    width: 100%;
    border-collapse: collapse;
    margin: 1.5rem 0;
    background: rgba(245, 245, 250, 0.5);
    border-radius: 0.5rem;
    overflow: hidden;
}

.dark .markdown-body table {
    background: rgba(22, 22, 38, 0.3);
}

.markdown-body table th {
    background: rgba(230, 230, 240, 0.75);
    padding: 0.5rem 1rem;
    text-align: left;
    font-weight: 600;
    border: 1px solid rgba(0, 0, 0, 0.1);
}

.dark .markdown-body table th {
    background: rgba(28, 28, 48, 0.75);
    border: 1px solid rgba(255, 255, 255, 0.08);
}

.markdown-body table td {
    padding: 0.5rem 1rem;
    border: 1px solid rgba(0, 0, 0, 0.1);
}

.dark .markdown-body table td {
    border: 1px solid rgba(255, 255, 255, 0.08);
}

.markdown-body ul,
.markdown-body ol {
    list-style-position: inside;
    margin-bottom: 1rem;
}

.markdown-body ul {
    list-style-type: disc;
}

.markdown-body ol {
    list-style-type: decimal;
}

.markdown-body li {
    margin-bottom: 0.25rem;
}

.markdown-body h1 {
    font-size: 1.5rem;
    font-weight: 700;
    margin-top: 1.5rem;
    margin-bottom: 1rem;
    color: #111827;
}

.dark .markdown-body h1 {
    color: #f8fafc;
}

.markdown-body h2 {
    font-size: 1.25rem;
    font-weight: 700;
    margin-top: 1.25rem;
    margin-bottom: 0.75rem;
    color: #111827;
}

.dark .markdown-body h2 {
    color: #f8fafc;
}

.markdown-body h3 {
    font-size: 1.125rem;
    font-weight: 600;
    margin-top: 1rem;
    margin-bottom: 0.5rem;
    color: #111827;
}

.dark .markdown-body h3 {
    color: #f8fafc;
}

.markdown-body p {
    margin-bottom: 1rem;
    color: #1f2937;
}

.dark .markdown-body p {
    color: #e5e7eb;
}

.markdown-body hr {
    margin: 1.5rem 0;
    border: 0;
    border-top: 1px solid rgba(0, 0, 0, 0.1);
}

.dark .markdown-body hr {
    border-top: 1px solid rgba(255, 255, 255, 0.08);
}

/* Fix for black redaction-like blocks */
.markdown-body p,
.markdown-body li,
.markdown-body h1,
.markdown-body h2,
.markdown-body h3,
.markdown-body h4,
.markdown-body h5,
.markdown-body h6 {
    background-color: transparent !important;
    color: inherit !important;
}

/* Override inline code styling to improve visibility */
.markdown-body :not(pre)>code {
    color: #6366f1 !important;
    background-color: rgba(99, 102, 241, 0.1) !important;
    padding: 0.2em 0.4em;
    border-radius: 3px;
    font-family: monospace;
    white-space: pre-wrap;
}

/* Fix for algorithm steps and formatted text */
.markdown-body ul li,
.markdown-body ol li {
    padding-left: 0.5rem;
    margin-left: 1.5rem;
    list-style-position: outside;
}

.markdown-body ol {
    list-style-type: decimal;
    padding-left: 1.5rem;
}

.markdown-body .algorithm-step {
    font-family: monospace;
    background: rgba(99, 102, 241, 0.05);
    padding: 0.25rem 0.5rem;
    border-radius: 4px;
    margin-bottom: 0.5rem;
}

/* Fix for math notation */
.markdown-body .math-inline,
.markdown-body .math-display {
    background-color: transparent !important;
}`, "",{"version":3,"sources":["webpack://./src/components/markdown-styles.css"],"names":[],"mappings":"AAAA;IACI,oCAAoC;IACpC,qBAAqB;IACrB,aAAa;IACb,cAAc;IACd,oCAAoC;IACpC,gBAAgB;AACpB;;AAEA;IACI,iCAAiC;IACjC,2CAA2C;AAC/C;;AAEA;IACI,qCAAqC;IACrC,sBAAsB;IACtB,sBAAsB;IACtB,gBAAgB;IAChB,WAAW;IACX,sBAAsB;AAC1B;;AAEA;IACI,kCAAkC;IAClC,cAAc;AAClB;;AAEA;IACI,uBAAuB;IACvB,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,8CAA8C;IAC9C,kBAAkB;IAClB,oBAAoB;IACpB,uBAAuB;IACvB,mBAAmB;IACnB,oCAAoC;IACpC,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,cAAc;IACd,0BAA0B;IAC1B,4BAA4B;AAChC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,gBAAgB;IAChB,oCAAoC;IACpC,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,qCAAqC;IACrC,oBAAoB;IACpB,gBAAgB;IAChB,gBAAgB;IAChB,oCAAoC;AACxC;;AAEA;IACI,kCAAkC;IAClC,2CAA2C;AAC/C;;AAEA;IACI,oBAAoB;IACpB,oCAAoC;AACxC;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;;IAEI,2BAA2B;IAC3B,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,sBAAsB;IACtB,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;IAChB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,SAAS;IACT,wCAAwC;AAC5C;;AAEA;IACI,+CAA+C;AACnD;;AAEA,wCAAwC;AACxC;;;;;;;;IAQI,wCAAwC;IACxC,yBAAyB;AAC7B;;AAEA,uDAAuD;AACvD;IACI,yBAAyB;IACzB,oDAAoD;IACpD,oBAAoB;IACpB,kBAAkB;IAClB,sBAAsB;IACtB,qBAAqB;AACzB;;AAEA,+CAA+C;AAC/C;;IAEI,oBAAoB;IACpB,mBAAmB;IACnB,4BAA4B;AAChC;;AAEA;IACI,wBAAwB;IACxB,oBAAoB;AACxB;;AAEA;IACI,sBAAsB;IACtB,oCAAoC;IACpC,uBAAuB;IACvB,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA,0BAA0B;AAC1B;;IAEI,wCAAwC;AAC5C","sourcesContent":[".markdown-body pre {\n    background: rgba(240, 240, 245, 0.9);\n    border-radius: 0.5rem;\n    padding: 1rem;\n    margin: 1rem 0;\n    border: 1px solid rgba(0, 0, 0, 0.1);\n    overflow-x: auto;\n}\n\n.dark .markdown-body pre {\n    background: rgba(28, 28, 48, 0.9);\n    border: 1px solid rgba(255, 255, 255, 0.08);\n}\n\n.markdown-body code {\n    background: rgba(240, 240, 245, 0.75);\n    border-radius: 0.25rem;\n    padding: 0.1rem 0.3rem;\n    font-size: 0.9em;\n    color: #333;\n    font-family: monospace;\n}\n\n.dark .markdown-body code {\n    background: rgba(28, 28, 48, 0.75);\n    color: #f8fafc;\n}\n\n.markdown-body pre code {\n    background: transparent;\n    padding: 0;\n    border-radius: 0;\n}\n\n.markdown-body blockquote {\n    border-left: 4px solid rgba(99, 102, 241, 0.5);\n    padding-left: 1rem;\n    padding-top: 0.25rem;\n    padding-bottom: 0.25rem;\n    margin-bottom: 1rem;\n    background: rgba(245, 245, 250, 0.5);\n    border-radius: 0.25rem;\n}\n\n.dark .markdown-body blockquote {\n    background: rgba(22, 22, 38, 0.3);\n}\n\n.markdown-body a {\n    color: #4f46e5;\n    text-decoration: underline;\n    transition: color 0.15s ease;\n}\n\n.dark .markdown-body a {\n    color: #6366f1;\n}\n\n.markdown-body a:hover {\n    color: #6366f1;\n}\n\n.dark .markdown-body a:hover {\n    color: #818cf8;\n}\n\n.markdown-body table {\n    width: 100%;\n    border-collapse: collapse;\n    margin: 1.5rem 0;\n    background: rgba(245, 245, 250, 0.5);\n    border-radius: 0.5rem;\n    overflow: hidden;\n}\n\n.dark .markdown-body table {\n    background: rgba(22, 22, 38, 0.3);\n}\n\n.markdown-body table th {\n    background: rgba(230, 230, 240, 0.75);\n    padding: 0.5rem 1rem;\n    text-align: left;\n    font-weight: 600;\n    border: 1px solid rgba(0, 0, 0, 0.1);\n}\n\n.dark .markdown-body table th {\n    background: rgba(28, 28, 48, 0.75);\n    border: 1px solid rgba(255, 255, 255, 0.08);\n}\n\n.markdown-body table td {\n    padding: 0.5rem 1rem;\n    border: 1px solid rgba(0, 0, 0, 0.1);\n}\n\n.dark .markdown-body table td {\n    border: 1px solid rgba(255, 255, 255, 0.08);\n}\n\n.markdown-body ul,\n.markdown-body ol {\n    list-style-position: inside;\n    margin-bottom: 1rem;\n}\n\n.markdown-body ul {\n    list-style-type: disc;\n}\n\n.markdown-body ol {\n    list-style-type: decimal;\n}\n\n.markdown-body li {\n    margin-bottom: 0.25rem;\n}\n\n.markdown-body h1 {\n    font-size: 1.5rem;\n    font-weight: 700;\n    margin-top: 1.5rem;\n    margin-bottom: 1rem;\n    color: #111827;\n}\n\n.dark .markdown-body h1 {\n    color: #f8fafc;\n}\n\n.markdown-body h2 {\n    font-size: 1.25rem;\n    font-weight: 700;\n    margin-top: 1.25rem;\n    margin-bottom: 0.75rem;\n    color: #111827;\n}\n\n.dark .markdown-body h2 {\n    color: #f8fafc;\n}\n\n.markdown-body h3 {\n    font-size: 1.125rem;\n    font-weight: 600;\n    margin-top: 1rem;\n    margin-bottom: 0.5rem;\n    color: #111827;\n}\n\n.dark .markdown-body h3 {\n    color: #f8fafc;\n}\n\n.markdown-body p {\n    margin-bottom: 1rem;\n    color: #1f2937;\n}\n\n.dark .markdown-body p {\n    color: #e5e7eb;\n}\n\n.markdown-body hr {\n    margin: 1.5rem 0;\n    border: 0;\n    border-top: 1px solid rgba(0, 0, 0, 0.1);\n}\n\n.dark .markdown-body hr {\n    border-top: 1px solid rgba(255, 255, 255, 0.08);\n}\n\n/* Fix for black redaction-like blocks */\n.markdown-body p,\n.markdown-body li,\n.markdown-body h1,\n.markdown-body h2,\n.markdown-body h3,\n.markdown-body h4,\n.markdown-body h5,\n.markdown-body h6 {\n    background-color: transparent !important;\n    color: inherit !important;\n}\n\n/* Override inline code styling to improve visibility */\n.markdown-body :not(pre)>code {\n    color: #6366f1 !important;\n    background-color: rgba(99, 102, 241, 0.1) !important;\n    padding: 0.2em 0.4em;\n    border-radius: 3px;\n    font-family: monospace;\n    white-space: pre-wrap;\n}\n\n/* Fix for algorithm steps and formatted text */\n.markdown-body ul li,\n.markdown-body ol li {\n    padding-left: 0.5rem;\n    margin-left: 1.5rem;\n    list-style-position: outside;\n}\n\n.markdown-body ol {\n    list-style-type: decimal;\n    padding-left: 1.5rem;\n}\n\n.markdown-body .algorithm-step {\n    font-family: monospace;\n    background: rgba(99, 102, 241, 0.05);\n    padding: 0.25rem 0.5rem;\n    border-radius: 4px;\n    margin-bottom: 0.5rem;\n}\n\n/* Fix for math notation */\n.markdown-body .math-inline,\n.markdown-body .math-display {\n    background-color: transparent !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
